import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
// import "firebase/compat/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDvDyaYrVDk9wkkIpfuva3Ww9SUQ7poGrA",
  authDomain: "denbaba-59dbd.firebaseapp.com",
  databaseURL: "https://denbaba-59dbd.firebaseio.com",
  projectId: "denbaba-59dbd",
  storageBucket: "denbaba-59dbd.appspot.com",
  messagingSenderId: "915177806652",
  appId: "1:915177806652:web:ba54417bff9f88c25d5c39",
  measurementId: "G-PRK141LY64",
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);
// export const analytics = firebaseApp.analytics();
export const firestoreTimestamp = firebase.firestore.Timestamp;
export const db = firebaseApp.firestore();
// Safari en contentblockers breken de streaming-verbinding van Firestore af.
// Auto-detect staat in deze SDK-versie standaard aan en hielp niet, dus forceren
// we long-polling. Iets trager, maar het werkt door proxies en blockers heen.
// Auto-detect moet expliciet uit: de SDK gooit een fout als beide true zijn.
db.settings({
  experimentalForceLongPolling: true,
  experimentalAutoDetectLongPolling: false,
  merge: true,
});
export const auth = firebaseApp.auth();
// Alle functions van dit project draaien in europe-west1.
export const functions = firebaseApp.functions("europe-west1");
